const VIOLATION_TYPES_LOOKUP = {
  BREAK: 0,
  SHIFT_DRIVING: 1,
  SHIFT_LIMIT: 2,
  CYCLE: 3,
  SHIFT_DUTY: 4,
  DAY_DRIVING: 5,
  DAY_DUTY: 6,
  DAY_2HR_OFF: 7,
  DAY_10HR_OFF: 8,
};

export function getViolationTypes(): { [violationId: number]: string } {
  return {
    [VIOLATION_TYPES_LOOKUP.SHIFT_DRIVING]: 'Drive Time Exceeded',
    [VIOLATION_TYPES_LOOKUP.SHIFT_LIMIT]: 'Shift Time Exceeded',
    [VIOLATION_TYPES_LOOKUP.CYCLE]: 'Cycle Time Exceeded',
    [VIOLATION_TYPES_LOOKUP.SHIFT_DUTY]: 'On Duty Time Exceeded',
    [VIOLATION_TYPES_LOOKUP.BREAK]: '30 Minute Break Needed',
  };
}
